<template>
    <div class="background">

        <slot></slot>

        <div class='light x1'></div>
        <div class='light x2'></div>
        <div class='light x3'></div>
        <div class='light x4'></div>
        <div class='light x5'></div>
        <div class='light x6'></div>
        <div class='light x7'></div>
        <div class='light x8'></div>
        <div class='light x9'></div>
    </div>
</template>

<script>

import Json from 'vue-json-pretty';
import {mapState, mapActions} from 'vuex';

const vuexModule = 'VuexStore';

export default {

    components: {
        Json
    },

    props: {},

    computed: {
        ...mapState(vuexModule, []),
    },

    data() {
        return {}
    },

    methods: {
        ...mapActions(vuexModule, []),
    }
}
</script>

<style scoped>

.background {
    margin: 0;
    height: 100vh;
    font-weight: 100;
    background: radial-gradient(#777777, #111111);
    overflow-y: hidden;
    animation: fadeIn 1 1s ease-out;
}

.light {
    position: absolute;
    width: 0px;
    opacity: .35;
    background-color: white;
    box-shadow: #CCCCCC 0px 0px 20px 2px;
    top: 100vh;
    bottom: 0px;
    left: 0px;
    right: 0px;
    margin: auto;
}

.x1 {
    animation: floatUp 4s infinite linear;
    transform: scale(1.0);
}

.x2 {
    animation: floatUp 7s infinite linear;
    transform: scale(2.6);
    left: 15%;
}

.x3 {
    animation: floatUp 2.5s infinite linear;
    transform: scale(1.5);
    left: -15%;
}

.x4 {
    animation: floatUp 4.8s infinite linear;
    transform: scale(2.6);
    left: -34%;
}

.x5 {
    animation: floatUp 8s infinite linear;
    transform: scale(1.5);
    left: -57%;
}

.x6 {
    animation: floatUp 3s infinite linear;
    transform: scale(2.6);
    left: -81%;
}

.x7 {
    animation: floatUp 5.3s infinite linear;
    transform: scale(1.2);
    left: 37%;
}

.x8 {
    animation: floatUp 4.7s infinite linear;
    transform: scale(1.7);
    left: 62%;
}

.x9 {
    animation: floatUp 4.1s infinite linear;
    transform: scale(0.9);
    left: 85%;
}

@keyframes floatUp {
    0% {
        top: 100vh;
        opacity: 0;
    }
    25% {
        opacity: 1;
    }
    50% {
        top: 0vh;
        opacity: .8;
    }
    75% {
        opacity: 1;
    }
    100% {
        top: -100vh;
        opacity: 0;
    }
}

@keyframes floatDown {
    0% {
        top: -100vh;
        opacity: 0;
    }
    25% {
        opacity: 1;
    }
    50% {
        top: 0vh;
        opacity: .8;
    }
    75% {
        opacity: 1;
    }
    100% {
        top: 100vh;
        opacity: 0;
    }
}

@-webkit-keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@-moz-keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@-o-keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@-webkit-keyframes fadeOut {
    0% {
        opacity: 0;
    }
    30% {
        opacity: 1;
    }
    80% {
        opacity: .9;
    }
    100% {
        opacity: 0;
    }
}

@-moz-keyframes fadeOut {
    0% {
        opacity: 0;
    }
    30% {
        opacity: 1;
    }
    80% {
        opacity: .9;
    }
    100% {
        opacity: 0;
    }
}

@-o-keyframes fadeOut {
    0% {
        opacity: 0;
    }
    30% {
        opacity: 1;
    }
    80% {
        opacity: .9;
    }
    100% {
        opacity: 0;
    }
}

@keyframes fadeOut {
    0% {
        opacity: 0;
    }
    30% {
        opacity: 1;
    }
    80% {
        opacity: .9;
    }
    100% {
        opacity: 0;
    }
}

@-webkit-keyframes finalFade {
    0% {
        opacity: 0;
    }
    30% {
        opacity: 1;
    }
    80% {
        opacity: .9;
    }
    100% {
        opacity: 1;
    }
}

@-moz-keyframes finalFade {
    0% {
        opacity: 0;
    }
    30% {
        opacity: 1;
    }
    80% {
        opacity: .9;
    }
    100% {
        opacity: 1;
    }
}

@-o-keyframes finalFade {
    0% {
        opacity: 0;
    }
    30% {
        opacity: 1;
    }
    80% {
        opacity: .9;
    }
    100% {
        opacity: 1;
    }
}

@keyframes finalFade {
    0% {
        opacity: 0;
    }
    30% {
        opacity: 1;
    }
    80% {
        opacity: .9;
    }
    100% {
        opacity: 1;
    }
}

</style>
